export {default} from './share-chat.vue'